import React from 'react';
import './LogoutConfirm.css';

export const LogoutConfirm = ({
  setShowLogout,
  setLogoutStarted,
  handleLogout,
  setDashboardblur,
  foranalytics,
}: {
  setShowLogout: (show: boolean) => void;
  setLogoutStarted: (started: boolean) => void;
  handleLogout: () => void;
  setDashboardblur: (blur: boolean) => void;
  foranalytics?: boolean;
}) => {
  const funcLogout = () => {
    setLogoutStarted(true);
    handleLogout();
  };

  const funcCancel = () => {
    if(!foranalytics) {
     setDashboardblur?.(false);
    }
    setShowLogout(false);
  };

  return (
    <div className="logout-popup" style={{ opacity: '1' }}>
      <p className="logout-popup-message">Are you sure you want to Logout?</p>
      <div className="logout-popup-buttons">
        <button className="cancel-button" onClick={funcCancel}>
          Cancel
        </button>
        <button className="logout-button" onClick={funcLogout}>
          Logout
        </button>
      </div>
    </div>
  );
};
